<template>
<div 
      v-if="alert" 
      :class="['alert', error ? 'alert-error' : 'alert-success']"
    >
         {{ alert }}
    </div>
</template>
<script setup lang='ts'>
const props = defineProps<{
    alert:string,
    error:boolean
}>()
</script>

<style lang="scss">
    .alert{
    padding: 10px 20px;
    border-radius: 5px;
    margin-bottom: 20px;
    &.alert-error{
        background-color: $alertBg;
        color: $alertText;
    }
    &.alert-success{
        background-color: $successBg;
        color:$successText;
    }
}
</style>